import React, { FC } from 'react';
import { Text, TextVariant } from '@naf/text';
import { SanityBlock } from '@dtp/membership-service-types/dist/sanity/sanity';
import BlockContent from '../block-content/BlockContent';
import { Wrapper, LoginButton } from './LoginComponent.styles';

interface LoginComponentProps {
  header: string;
  body: SanityBlock[];
  buttonText: string;
  onLogin: () => void;
}

export const LoginComponent: FC<LoginComponentProps> = ({ header, body, buttonText, onLogin }) => (
  <Wrapper>
    <Text tag="h3" variant={TextVariant.Header3}>
      {header}
    </Text>
    <BlockContent value={body} />
    <LoginButton type="button" onClick={onLogin}>
      {buttonText}
    </LoginButton>
  </Wrapper>
);
